import { SenderListInterface } from '@feature/dashboard/senders/types/sender-list';
import { Country, CountryInfo } from '@sharedModule/models/country.model';

export const getCountryInfoFromAlpha3 = (
  alpha3: string,
  countryData: Country[] | null
): Country | undefined => {
  const selectedCountry = countryData!.find(x => x.alpha3 === alpha3);
  return selectedCountry ? selectedCountry : undefined;
};

export const getCountryInfoFromCountryName = (
  countryName: string,
  countryData: Country[] | null
): Country | undefined => {
  const selectedCountry = countryData!.find(
    x => x.country_name === countryName
  );
  return selectedCountry ? selectedCountry : undefined;
};

export const getCountryInfoFromCountryCode = (
  countryCode: string,
  countryData: CountryInfo[] | null
): CountryInfo | undefined => {
  const selectedCountry = countryData!.find(x => x.countryCode === countryCode);
  return selectedCountry ?? undefined;
};

export const getSourceCountryInfoFromCountryName = (
  countryName: string,
  countryData: CountryInfo[] | null
): CountryInfo | undefined => {
  const selectedCountry = countryData!.find(x => x.countryName === countryName);
  return selectedCountry ?? undefined;
};

export const getSenderDetailsFromId = (
  id: number,
  senderList: SenderListInterface[] | null
): SenderListInterface | undefined => {
  const selectedSender = senderList!.find(x => x.sender_id === id);
  return selectedSender ?? undefined;
};
